<template>
  <div
    v-if="show"
    class="fixed top-4 right-4 z-50 flex items-center p-4 rounded-lg shadow-lg transition-all duration-300 transform"
    :class="[
      type === 'error'
        ? isDarkMode
          ? 'bg-red-900 text-red-100 border border-red-800'
          : 'bg-red-50 text-red-700 border border-red-100'
        : isDarkMode
          ? 'bg-green-900 text-green-100 border border-green-800'
          : 'bg-green-50 text-green-700 border border-green-100',
      show ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
    ]"
  >
    <!-- Icon -->
    <div class="flex-shrink-0 mr-3">
      <svg
        v-if="type === 'error'"
        class="w-5 h-5"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
          clip-rule="evenodd"
        />
      </svg>
      <svg
        v-else
        class="w-5 h-5"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clip-rule="evenodd"
        />
      </svg>
    </div>

    <!-- Content -->
    <div class="flex-1">
      <p class="text-sm font-medium">{{ message }}</p>
      <ul
        v-if="details && details.length"
        class="mt-1 text-sm list-disc list-inside"
      >
        <li
          v-for="(detail, index) in details"
          :key="index"
        >
          {{ detail }}
        </li>
      </ul>
    </div>

    <!-- Close button -->
    <button
      class="ml-4 flex-shrink-0 text-sm opacity-75 hover:opacity-100 focus:outline-none"
      @click="handleClose"
    >
      <svg
        class="w-4 h-4"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, watch, computed } from 'vue'
import themeService from '../../../services/theme/themeService'

const props = defineProps<{
  show: boolean
  message: string
  type: 'error' | 'success'
  details?: string[]
  duration?: number
}>()

const isDarkMode = computed(() => themeService.isDark.value)

const emit = defineEmits<{
  (e: 'update:show', value: boolean): void
}>()

const handleClose = () => {
  emit('update:show', false)
}

// Auto-hide toast after duration
watch(
  () => props.show,
  (newValue) => {
    if (newValue && props.duration) {
      setTimeout(() => {
        emit('update:show', false)
      }, props.duration)
    }
  }
)
</script>
